export default {
    data() {
        return {
            // 下载批量上传模板
            download: this.baseUrl + 'excel_template/project.xlsx',
            // 批量上传路径
            action: this.baseUrl + 'projects/importPackages?token=' + this.$store.state.authority_management,

            // 下载自动分配分数模板
            // download2: this.baseUrl + 'excel_template/allocation.xlsx',
            download2: 'https://education-project.bayou-tech.cn/excel_template/allocation.xlsx',
            // 自动分配分数路径
            action2: this.baseUrl + 'purchased/allocationScore?token=' + this.$store.state.authority_management,

            // 下载课程模板
            download3: this.baseUrl + 'zip_template/课程导入模板.zip',
            // 上传课程模板
            action3: this.baseUrl + `import/importProject?token=${this.$store.state.authority_management}&shop_id=8`,

            // 下载任务模板
            download4: this.baseUrl + 'excel_template/任务导入模板.xls',
            // 上传任务模板
            action4: this.baseUrl + `import/importTask?token=${this.$store.state.authority_management}&shop_id=8`,

            // 下载视频资源模板
            download5: this.baseUrl + 'excel_template/视频资源导入模板.xls',
            // 上传视频资源模板
            action5: this.baseUrl + `import/importCourseWareAndEBook?token=${this.$store.state.authority_management}&type=视频&shop_id=8`,

            // 下载电子书资源模板
            download6: this.baseUrl + 'zip_template/电子书阅读模板.zip',
            // 上传电子书资源模板
            action6: this.baseUrl + `import/importCourseWareAndEBook?token=${this.$store.state.authority_management}&type=电子书阅读&shop_id=8`,

            // 下载课程作业资源模板
            download7: this.baseUrl + 'excel_template/课程作业导入模板.xls',
            // 上传课程作业资源模板
            action7: this.baseUrl + `import/importWorkThemeOJT?token=${this.$store.state.authority_management}&type=课程作业&shop_id=8`,

            // 下载主题讨论资源模板
            download8: this.baseUrl + 'excel_template/主题讨论导入模板.xls',
            // 上传主题讨论资源模板
            action8: this.baseUrl + `import/importWorkThemeOJT?token=${this.$store.state.authority_management}&type=主题讨论&shop_id=8`,
            
            // 下载活动资源模板
            download9: this.baseUrl + 'excel_template/活动导入模板.xls',
            // 上传活动资源模板
            action9: this.baseUrl + `import/importActivity?token=${this.$store.state.authority_management}&shop_id=8`,

            // 下载项目关联任务模板
            download10: this.baseUrl + 'excel_template/项目关联任务导入模板.xls',
            // 上传项目关联任务模板
            action10: this.baseUrl + `import/importCourseTask?token=${this.$store.state.authority_management}&shop_id=8`,

            loading3: false,
            loading4: false,
            loading5: false,
            loading6: false,
            loading7: false,
            loading8: false,
            loading9: false,
            loading10: false,
        }
    },
    methods: {
        // 上传
        httpreq(q) {
            this.$upload(this.action, q).then(res => {
                this.$alert(`${res.data.result.msg}`, '提示', {
                    confirmButtonText: '确定'
                })
            })
        },

        // 分配分数
        httpreq2(q) {
            this.$upload(this.action2, q).then(res => {
                console.log(res);
                if (res.data.status === 'success') {
                    this.$alert(`${res.data.result.msg}`, '提示', {
                        confirmButtonText: '确定'
                    });
                } else {
                    this.$alert(`${res.data.result.errorMsg}`, '提示', {
                        confirmButtonText: '确定'
                    });
                }
            })
        },

        // 上传课程
        httpreq3(q) {
            this.loading3 = true;
            this.$upload(this.action3, q).then(res => {
                this.loading3 = false;
                this.alertTip(res);
            });
        },

        // 上传任务
        httpreq4(q) {
            this.loading4 = true;
            this.$upload(this.action4, q).then(res => {
                this.loading4 = false;
                this.alertTip(res);
            });
        },

        // 上传视频资源
        httpreq5(q) {
            this.loading5 = true;
            this.$upload(this.action5, q).then(res => {
                this.loading5 = false;
                this.alertTip(res);
            });
        },

        // 上传电子书资源
        httpreq6(q) {
            this.loading6 = true;
            this.$upload(this.action6, q).then(res => {
                this.loading6 = false;
                this.alertTip(res);
            })
        },

        // 上传课程作业资源
        httpreq7(q) {
            this.loading7 = true;
            this.$upload(this.action7, q).then(res => {
                this.loading7 = false;
                this.alertTip(res);
            })
        },

        // 上传主题讨论资源
        httpreq8(q) {
            this.loading8 = true;
            this.$upload(this.action8, q).then(res => {
                this.loading8 = false;
                this.alertTip(res);
            })
        },

        // 上传活动资源
        httpreq9(q) {
            this.loading9 = true;
            this.$upload(this.action9, q).then(res => {
                this.loading9 = false;
                this.alertTip(res);
            })
        },

        // 上传项目关联任务
        httpreq10(q) {
            this.loading10 = true;
            this.$upload(this.action10, q).then(res => {
                this.loading10 = false;
                this.alertTip(res);
            })
        },

        // 文件上传之前验证
        beforeUpload(file) {
            let isZip = file.type === 'application/x-zip-compressed'
            let isLt1G = file.size / 1024 / 1024 < 1024

            if (!isZip) {
                this.$alert('请上传.zip压缩包文件', '提示', {
                    confirmButtonText: '确定'
                })
            }

            if (!isLt1G) {
                this.$alert('上传的文件大小不能超出1G', '提示', {
                    confirmButtonText: '确定'
                })
            }

            return isZip && isLt1G
        },

        // 提示
        alertTip(res) {
            if (res.data.status === 'success') {
                this.$alert(`${res.data.result}`, '提示', {
                    confirmButtonText: '确定'
                });
            } else {
                this.$alert(`${res.data.errorMsg}`, '提示', {
                    confirmButtonText: '确定'
                });
            }
        }
    },
}